import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, retry, shareReplay } from 'rxjs';
import { AppSettings } from '../app-settings';
import { VisitationZone } from 'src/models/visitationZone';
import { VisitationFamily, VisitationFamilyDetails, VisitationFamilyStatusChange, VisitationVisitType } from 'src/models/vistationFamily';
import { Visitation } from 'src/models/visitation';
import { Parish } from 'src/models/parish';
import { Family } from 'src/models/family';

@Injectable({
    providedIn: 'root',
})
export class VisitationService {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings) { }

    getVisitationZones(): Observable<VisitationZone[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetVisitationZones`;

        return this.http.get<VisitationZone[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getFamilyMembers(): Observable<VisitationFamily[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetFamilies`;

        return this.http.get<VisitationFamily[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    
    getNewFamilyMembers(visitationId: number): Observable<Family[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetNewFamilies?visitationId=${visitationId}`;

        return this.http.get<Family[]>(url, this.httpOptions)
            .pipe(retry({ count: 2, delay: 500 }), shareReplay());
    }

    GetVisitations(vistationId: number = 0, isFutureDates: boolean = true): Observable<Visitation[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetVisitations?visitationId=${vistationId}&isFutureDates=${isFutureDates}`;

        return this.http.get<Visitation[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    GetFamiliesByVisitationId(visitationId: number): Observable<VisitationFamilyDetails[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetFamiliesByVisitationId?visitationId=${visitationId}`;

        return this.http.get<VisitationFamilyDetails[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    GetVisitingPriests(): Observable<Parish[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetPriests`;

        return this.http.get<Parish[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    GetVisitTypes(): Observable<VisitationVisitType[]> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/GetVisitiationVisitTypes`;

        return this.http.get<VisitationVisitType[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    saveVisitationZones(zone: VisitationZone[]): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/SaveVisitationZones`;

        return this.http.post<boolean>(url, zone, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    saveFamilyMemberZone(families: VisitationFamily[]): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/SaveFamilyVisitationZones`;
        return this.http.post<boolean>(url, families, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    saveVisitation(visit: Visitation): Observable<number> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/SaveVisitation`;
        return this.http.post<number>(url, visit, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    saveVisitationFamily(fam: VisitationFamilyStatusChange): Observable<number> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/SaveVisitationFamily`;
        return this.http.post<number>(url, fam, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    assignNewFamiliesToEvent(visitationId: number, familyIds: number[]): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + `Visitation/AssignNewFamiliesToEvent?visitationId=${visitationId}`;
        return this.http.post<boolean>(url, familyIds, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }
}